import React from 'react';
import {Site} from "../../types/Site";
import {useQuery} from "react-query";
import ngage from 'services/ngage';
import {useOperator} from "../../context/OperatorContext";

// Types ----

type SiteSelectProps = {
  id: string
  name: string
  label: string
  value?: number | string | null
  onChange: (site: Site | null) => any
  showAnySiteOption?: boolean
}

// Helpers ----

function findSite(sites: Array<Site>, id: number | string): Site | null {
  return sites.find(site => site.id.toString() === id.toString()) ?? null
}

// Component ----

function SiteSelect({id, name, label, value, onChange, showAnySiteOption = true}: SiteSelectProps) {
  const {termFor} = useOperator();

  const {data: sites, isLoading} = useQuery(
    ['sites.all'],
    () => ngage.sites.all(),
  )

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <select
        id={id}
        name={name}
        className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm"
        value={value ?? undefined}
        onChange={event => onChange(findSite(sites?.data ?? [], event.currentTarget.value))}
      >
        {showAnySiteOption && <option value="">Any {termFor('Site')}</option>}

        {!isLoading && sites?.data.map(site => (
          <option value={site.id} key={site.id}>
            {site.name}
          </option>
        ))}
      </select>
    </div>
  );
}

// Export ----

export default SiteSelect;